import React from 'react';
import CheckList from './Check/CheckList';
import RadioList from './Radio/RadioList';
import Props from './typings';

const List = ({type = 'radio', style = 'text', selected, options, group, callback}: Props) => {
  const list = {
    check: CheckList,
    radio: RadioList,
  } as const;

  const ListType = list[type];

  return (
    <ListType
      options={options}
      selected={selected}
      group={group}
      style={style}
      callback={callback}
    />
  );
};

export default List;
